import { render, staticRenderFns } from "./PredictionChartsYear.vue?vue&type=template&id=9a972c42&"
import script from "./PredictionChartsYear.vue?vue&type=script&lang=js&"
export * from "./PredictionChartsYear.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports